// Module
var code = `<!-- ko with: \$data.item -->
<div data-bind="css: data.containerCss">
  <span data-bind="css: data.additionalTitleCss, text: data.additionalTitle"></span>
  <!-- ko component: { name: 'sv-action-bar-item-dropdown', params: { item: \$data } } -->
  <!-- /ko -->
</div>
<!-- /ko -->`;
// Exports
export default code;